<template lang="pug">
  div
    b-row
      .col-xl-12
        panel(:title='$t("ui.account_action_log")')
          b-card
            b-row.flex(slot="header")
              .col-sm-12.col-md-6.col-lg-8.col-xl-6.mb-1
                DatePicker
              .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.account_id')" size="sm")
                  DebounceInput(
                    type="text"
                    ref="account_id"
                    :placeholder='$t("ui.account_id")'
                    v-model="account_id"
                    size="sm"
                    @keyup.enter.native="submit"
                  )
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
                b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
              .col-sm-12.col-md-6.col-lg-6.col-xl-2
                SubmitButton(:loading="loading" icon="fa fa-search" :text="$t('ui.search')" isModal=false type="button" @click="submit")
            b-row
              .col-sm-12.col-md-8.col-lg-9.col-xl-10.mb-1
                b-pagination(size="sm" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" @input="submit")
              .col-sm-12.col-md-4.col-lg-3.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="perPage" @input="changedPageSize")
              .col-sm-12.col-md-12.col-lg-12.col-xl-12
                b-table#tblList.table-sm.table-hover.table-bordered(striped show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="accountActionList" :fields="fields" :per-page="perPage" :filter="filter" @sort-changed="sortingChanged")
                  template(v-slot:cell(index)="row")
                    span {{ row.index + 1 }}
                  template(v-slot:cell(action_date)="row")
                    span {{ $moment(row.item.action_date).format("YYYY-MM-DD HH:mm:ss") }}
                  template(v-slot:cell(account_id)="row")
                    span {{ row.item.account_id.toUpperCase() }}
                  template(v-slot:cell(login_id)="row")
                    span {{ row.item.login_id.toUpperCase() }}
                  //- template(v-slot:cell(remark)="row")
                  //-   span(v-if="row.item.remark") {{ $t("error." + row.item.remark) }}
                  template(v-slot:cell(action_by)="row")
                    span {{ row.item.action_by.toUpperCase() }}


</template>

<script>
import { required } from "vuelidate/lib/validators";
import moment from "moment";
import store from "@/store";
import SubmitButton from "@/library/SubmitButton.vue";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import DatePicker from "@/library/DatePicker.vue";
export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    DateRangePicker,
    DatePicker
  },
  data() {
    return {
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      account_id: "",
      accountActionList: [],
      filter: null,
      sortBy: "log_id",
      sortDesc: true,
      currentPage: 1,
      totalRows: 0
    };
  },
  validations: {},
  beforeRouteEnter(to, from, next) {
    const end_date = moment().format("YYYY-MM-DD");
    const start_date = moment().subtract(7, "days").format("YYYY-MM-DD");
    store.dispatch("layout/setDateRange", {
      startDate: start_date,
      endDate: end_date
    });
    next();
  },
  beforeRouteLeave(to, from, next) {
    const today = this.$moment().format("YYYY-MM-DD");
    this.$store.dispatch("layout/setDateRange", {
      startDate: today,
      endDate: today
    });
    next();
  },
  computed: {
    dateRange() {
      return {
        startDate: this.$moment(this.$store.getters.dateRange.startDate).format("YYYY-MM-DD"),
        endDate: this.$moment(this.$store.getters.dateRange.endDate).format("YYYY-MM-DD")
      }
    },
    fields() {
      return [
        {
          key: "index",
          label: "#",
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "3%"
          }
        },
        {
          key: "action_date",
          label: this.$t("ui.date_time"),
          sortable: true,
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "account_id",
          label: this.$t("ui.account_id"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "login_id",
          label: this.$t("ui.login_id"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "action_type",
          label: this.$t("ui.remark"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "action_by",
          label: this.$t("ui.action_by"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "10%"
          }
        }
      ]
    },
    perPage() {
      return this.$store.getters.pageSize
    },
    direction() {
      return this.sortDesc ? "DESC" : "ASC"
    }
  },
  mounted: function() {
    this.submit()
  },
  methods: {
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize)
      this.currentPage = 1
      this.submit()
    },
    sortingChanged(ctx) {
      if (ctx.sortBy !== this.sortBy) {
        this.sortDesc = false
      } else {
        this.sortDesc = this.direction === "ASC"
      }

      this.sortBy = ctx.sortBy
      this.submit()
      this.refreshTable("tblList")
    },
    refreshTable(table) {
      this.$root.$emit("bv::table::refresh", table)
    },
    submit: function() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        let search_id = this.account_id
        let start_date = this.dateRange.startDate
        let end_date = this.dateRange.endDate
        let page_number = this.currentPage
        this.currentPage = parseInt(page_number)
        let page_size = this.perPage
        let sort_key = this.sortBy
        let sort_type = this.direction
        this.loading = true
        this.$store
          .dispatch("log/getAccountActionLog", { search_id, start_date, end_date, page_number, page_size, sort_key, sort_type })
          .then(response => {
            this.loading = false
            this.submission.success = response.success
            this.submission.status = response.errorTag
            if (this.submission.success == true) {
              // console.log(response.data)
              // if(response.data.length > 0) {
              this.accountActionList = response.data
              // }
            }
          })
          .catch(response => {
            this.loading = false
            this.submission.success = response.success
            this.submission.status = this.$t("message." + response.errorTag)
          });
      }
    }
  }
};
</script>

